import { useRef } from "react";

/**
 * useSwipe — attach touch swipe handlers to any element.
 * Threshold: 50px minimum horizontal delta, and horizontal must beat vertical (avoid confusing with scroll).
 *
 * Usage:
 *   const swipe = useSwipe({ onLeft: next, onRight: prev });
 *   <div {...swipe}> ... </div>
 */
export function useSwipe({ onLeft, onRight, threshold = 50 } = {}) {
  const start = useRef(null);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY };
  };

  const onTouchEnd = (e) => {
    if (!start.current) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - start.current.x;
    const dy = t.clientY - start.current.y;
    start.current = null;
    if (Math.abs(dx) < threshold) return;
    if (Math.abs(dx) < Math.abs(dy)) return; // vertical scroll wins
    if (dx < 0) onLeft && onLeft();
    else onRight && onRight();
  };

  return { onTouchStart, onTouchEnd };
}
